import { Link } from "react-router-dom";
import { MapPin, Mail } from "lucide-react";
import { COMPANY } from "@/constants/company";

export default function Footer() {
  return (
    <footer className="border-t border-navy-600/60 bg-navy-800" data-testid="site-footer">
      <div className="mx-auto grid max-w-7xl gap-12 px-6 py-16 md:grid-cols-2 md:px-12 lg:grid-cols-4">
        <div>
          <div className="flex items-center gap-3">
            <img
              src={COMPANY.logo}
              alt={`${COMPANY.name} logo`}
              className="h-11 w-11 rounded-full object-cover ring-1 ring-navy-600"
            />
            <span className="font-heading text-base font-bold text-white">EXCELLENT TRADERS</span>
          </div>
          <p className="mt-4 text-sm leading-relaxed text-slate-400">
            Singapore-based trading house for bitumen, lubricants and petrochemicals — connecting verified
            suppliers and buyers across Asia and emerging markets.
          </p>
        </div>

        <div>
          <h3 className="font-mono text-xs uppercase tracking-[0.25em] text-brand">Pages</h3>
          <ul className="mt-4 space-y-2 text-sm">
            <li><Link to="/" className="text-slate-300 transition-colors hover:text-brand" data-testid="footer-link-home">Home</Link></li>
            <li><Link to="/contact" className="text-slate-300 transition-colors hover:text-brand" data-testid="footer-link-contact">Contact</Link></li>
          </ul>
        </div>

        <div>
          <h3 className="font-mono text-xs uppercase tracking-[0.25em] text-brand">Businesses</h3>
          <ul className="mt-4 space-y-2 text-sm">
            <li><Link to="/bitumen" className="text-slate-300 transition-colors hover:text-brand" data-testid="footer-link-bitumen">Bitumen</Link></li>
            <li><Link to="/lubricants" className="text-slate-300 transition-colors hover:text-brand" data-testid="footer-link-lubricants">Lubricants</Link></li>
            <li><Link to="/petrochemicals" className="text-slate-300 transition-colors hover:text-brand" data-testid="footer-link-petrochemicals">Petrochemicals</Link></li>
          </ul>
        </div>

        <div>
          <h3 className="font-mono text-xs uppercase tracking-[0.25em] text-brand">Head Office</h3>
          <address className="mt-4 space-y-3 text-sm not-italic text-slate-300">
            <p className="flex items-start gap-2" data-testid="footer-address">
              <MapPin className="mt-0.5 h-4 w-4 shrink-0 text-brand" />
              <span>{COMPANY.address}</span>
            </p>
            <p className="flex items-start gap-2">
              <Mail className="mt-0.5 h-4 w-4 shrink-0 text-brand" />
              <a href={`mailto:${COMPANY.email}`} className="transition-colors hover:text-brand" data-testid="footer-email">
                {COMPANY.email}
              </a>
            </p>
          </address>
        </div>
      </div>
      <div className="border-t border-navy-600/60 py-6 text-center text-xs text-slate-500">
        Copyright © 2026 {COMPANY.name}. All rights reserved.
      </div>
    </footer>
  );
}
